import React from "react";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import PageHero from "@/components/site/PageHero";
import BottomCTA from "@/components/site/BottomCTA";
import FrameworkTabs from "@/components/site/FrameworkTabs";
import useReveal from "@/hooks/useReveal";
import { FRAMEWORK } from "@/data/investments";

export default function InvestmentFramework() {
  useReveal();
  return (
    <div className="min-h-screen bg-white text-unik-ink">
      <SiteNav />

      <PageHero
        eyebrow="Investment / Framework"
        title="Multiple structures."
        accent={<><br/>One discipline.</>}
        sub="Capital structured to match the maturity, capital intensity, and control needs of each platform."
        bgImage="/assets/9eitpmqk_hanoi-building.jpg"
      />

      <section className="relative bg-[#f4f5f7] py-28 lg:py-36">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div data-reveal className="max-w-3xl mb-14 lg:mb-16">
            <div className="eyebrow text-[#14355a]">Investment Framework</div>
            <h2
              style={{ fontSize: "clamp(2.25rem, 5vw, 4.5rem)", fontWeight: 500, lineHeight: "1.05" }}
              className="mt-6 font-display text-[#14355a] tracking-tight"
            >
              Multiple structures.<br/>One discipline.
            </h2>
            <p className="mt-8 text-[18px] lg:text-[19px] leading-[1.95] text-unik-ink/80 max-w-3xl">
              Unik structures capital to match the maturity, capital intensity,
              and control needs of each platform. Because no single ownership
              model suits every asset, we choose from a defined set of
              structures and apply the one that best balances control, capital
              efficiency, and risk at each stage of a platform&apos;s life.
            </p>
          </div>

          <FrameworkTabs items={FRAMEWORK} />
        </div>
      </section>

      <BottomCTA
        eyebrow="Continue Reading"
        title="See our"
        accent="portfolio composition."
        body="Three pillars of long-term capital — foundational assets, partnerships, and the Chitta healthspan ecosystem."
        primary={{ label: "Portfolio Composition", to: "/investments/composition" }}
        secondary={{ label: "Investment Approach", to: "/investments/approach" }}
      />

      <SiteFooter />
    </div>
  );
}
